import { render, staticRenderFns } from "./MediaLightbox.vue?vue&type=template&id=28237810"
import script from "./MediaLightbox.vue?vue&type=script&lang=js"
export * from "./MediaLightbox.vue?vue&type=script&lang=js"
import style0 from "./MediaLightbox.vue?vue&type=style&index=0&id=28237810&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports